import { selectProposeLoanMaturityMonths } from "../../../features/propose-data/propose-data-slice";
import { PRODUCT_TYPE_IDS } from "../../../constant/gms-constant";
import ProposedAmendChannelType from "./proposed-amend-channel-type";
import ProposedAmendClientBasicInformation from "./proposed-amendment/proposed-amend-client-basic-information";
import ProposedAmendGroupProfile from "./proposed-amendment/proposed-amend-group-profile";
import ProposedProposalConfiguration from "./proposed-amendment/proposed-amend-configuration";
import { useProposalTypeData } from "../../../hooks/proposal/use-proposal-type-data";
import ProposedCoverageLoan from "./proposed-amendment/proposed-amend-coverage-loan";
import ProposedCommissionServiceFee from "./proposed-amendment/proposed-amend-commission-service-fee";
import ProposedSupportingDocuments from "./proposed-amendment/proposed-amend-supporting-documents";
import ProposedAmendRiders from "./proposed-amendment/proposed-amend-riders";
import ProposedAmendBorrowers from "./proposed-amendment/proposed-amend-borrowers";
import { visibleRemainingAge } from "../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice";
import ProposedAmendNotes from "./proposed-amendment/proposed-amend-notes";
import { useProposedTypeData } from "../../../hooks/proposal/use-proposed-type-data";
import { useSelector } from "react-redux";

export default function ProposeProposalView() {

    const isPreview: boolean = true
    const {
        // CHANNEL TYPE
        proposedChanelType,
        proposedChannelEmail,
        proposedChannelNumber,
        proposedChannelSubName,
        proposeShowInputChanelType,

        // PROPOSAL AS (NEW/RENEW)
        proposedProposalAs,

        // BASIC INFORMATION
        proposedBasicInformation,
        proposedNatureOfBusinessItem,
        proposeCompanyContactNumber,
        proposeContactPersonNumber,

        // AFFILIATIONS
        proposedAffiliations,

        // GROUP CLASSIFICATION
        proposedGroupClassification,
        proposedHasOtherSpecifyGC,
        proposedOtherSpecifGC,

        // TYPE OF GROUP
        proposedTypeOfGroup,
        proposedOthersTypeOfGroup,
        proposedTypeOfGroupSubtype,
        proposedIsEmployerEmployeeToG,
        proposedIsOFWToG,
        proposedHasSubTypeToG,

        // AGE PROFILE
        proposedAgeProfile,
        proposedAgeProfileFormat,

        // MODE OF PAYMENT
        proposedModeOfPayment,

        // PROPOSAL TYPE (Customize/Prototype)
        proposedProposalType,
        proposedIsPrototype,
        proposedIsCustomize,

        // PROTOTYPE TYPE
        proposedPrototypeType,

        // PRODUCT TYPE
        proposedProductType,
        proposedIsProductGPA,
        proposedIsProductGCLI,
        proposedIsProductGYRT,
        proposedIsProductGCI,
        proposedIsCoverageType,
        proposedIsAmountOfLoans,

        // BASIC PLAN
        proposedBasicPlan,

        // COVERAGE TYPE
        proposedCoverageType,
        proposedIsLevelRanking,
        proposedIsUniformCoverage,
        proposedIsSalaryRank,
        proposedIsLevelRankingAndSalaryRank,

        // Level Ranking Coverage
        proposedLevelRankingInputs,
        proposedLevelRankingRiders,
        // Uniform Coverage
        proposedUniformInputs,
        proposedUniformRiders,
        // Salary Rank Coverage
        proposedSalaryRankInputs,
        proposedSalaryRankRiders,
        
        // Riders 
        proposedRiders,
        proposedRiderBMSR,

        // AMOUNT OF LOANS
        proposedAmountOfLoans,
        proposedAmountOfLoansRiders,
        proposedMinAmountOfLoans,
        proposedMaxAmountOfLoans,
        proposedFAmountMin,
        proposedFAmountMax,
        proposedFormatMinMaxAmount,
        proposedAmountOfLoansPortfolio,
        proposedFAmountPortfolio,

        // PAYMENT TERM
        proposedPaymentTerm,

        // LOAN MATURITY
        proposedLoanMaturityMonths,
        proposedMaturityMonthsFormat,

        // COMMISSION / SERVICE FEE
        proposedCommissionValue,
        proposedServiceValue,

        // BORROWER AGE
        prosedBorrowerAgeOptionsList,
        proposedMinAge,
        proposedMaxAge,
        proposedRemainingAgeList,

        // SUPPORTING DOCUMENTS
        proposedFiles,

        // NOTES
        proposedNotes,
    } = useProposedTypeData()
    
    const {
        channelType: currentChannelType,
        channelTypeSubName: currentChannelSubName,
        channelTypeNumber: currentChannelSubNumber,
        channelTypeEmail: currentChannelSubEmail,
        natureOfBusinessItem: currentNatureOfBusinessItem,
        proposalTypeState: currentProposalTypeState,
        basicInformation: currentInfo,
        affiliation: currentAffiliations,
        isProductGYRT: currentIsProductGYRT,
        isProductGPA: currentIsProductGPA,
        isProductGCI: currentIsProductGCI,
        isProductGCLI: currentIsProductGCLI,
        isLevelRanking: currentIsLevelRankingCoverage,
        isUniformCoverage: currentIsUniformCoverage,
        isSalaryRank: currentIsSalaryRankCoverage,
        isAmountOfLoansSelected: currentIsAmountOfLoans,
        groupClassification: currentGroupClassification,
        othersGroupClassificationValue: currentOthersGroupClassificationValue,
        typeOfGroup: currentTypeOfGroup,
        othersTypeOfGroupValue: currentOthersTypeOfGroupValue,
        typeOfGroupSubType: currentTypeOfGroupSubType,
        ageProfile: currentAgeProfile,
        ageProfileFormat: currentAgeProfileFormat,
        modeOfPayment: currentModeOfPayment,
        isCustomize: isCurrentCustomized,
        isPrototypeProposal: isCurrentPrototype,
        prototype: currentPrototype,
        product: currentProduct,
        basicPlan: currentBasicPlan,
        coverage: currentCoverage,
        inputsByLevelRanking: currentInputsByLevelRanking,
        inputsByUniformCoverage: currentInputsByUniformCoverage,
        inputsBySalaryRank: currentInputsBySalaryRank,
        amountOfLoans: currentAmountOfLoans,
        // minAmountOfLoans: currentMinAmountOfLoans,
        formatMinMaxAmount: currentFormatMinMaxAmount,
        portfolioOfLoans: currentPortfolioOfLoans,
        fAmountPortfolio: currentFAmountPortfolio,
        paymentTerm: currentPaymentTerm,
        maturityMonths: currentMaturityMonths,
        commission: currentCommission,
        services: currentServices,
        filesCFE: currentFilesCFE,
        riders: currentRiders,
        ridersAmountOfLoans: currentRidersAmountOfLoans,
        ridersUniformCoverage: currentRidersUniformCoverage,
        ridersLevelRanking: currentRidersLevelRanking,
        ridersSalaryRank: currentRidersSalaryRank,
        ridersBMSR: currentRidersBMSR,
        borrowerAgeOptionsList: currentBorrowerAgeOptionsList,
        notesCFE: currentNotesCFE,
    } = useProposalTypeData()

    const currentIsAmountOfLoansSelected: boolean = currentProposalTypeState?.id === PRODUCT_TYPE_IDS.GCLI
    const currentCoverageTypeSelected: boolean =  (currentIsProductGYRT || currentIsProductGPA || currentIsProductGCI) 
    const currentConfigurationType =
        currentIsAmountOfLoansSelected
            ? 'amountLoans'
            : currentCoverageTypeSelected
                ? 'coverage'
                : 'none';
    const proposedConfigurationType =
        proposedIsAmountOfLoans
            ? 'amountLoans'
            : proposedIsCoverageType
                ? 'coverage'
                : 'none';

    const proposedMaturityMonths = useSelector(selectProposeLoanMaturityMonths);
    const currentRemainingAgeList = useSelector(visibleRemainingAge).filter(item => item.typeOfAge !== "under_min");

    return (
        <>
            <div className="grid grid-cols-1 gap-3.5 ">
                <ProposedAmendChannelType
                    isShow={true}
                    current={{
                        channelTypeId: currentChannelType?.id,
                        channelTypeName: currentChannelType?.name,
                        channelSubName: currentChannelSubName,
                        channelSubNumber: currentChannelSubNumber,
                        channelSubEmail: currentChannelSubEmail,
                    }}
                    proposed={{
                        channelTypeId: proposedChanelType?.id,
                        channelTypeName: proposedChanelType?.name,
                        channelSubName: proposedChannelSubName,
                        channelSubNumber: proposedChannelNumber,
                        channelSubEmail: proposedChannelEmail,
                    }}
                />
                <ProposedAmendClientBasicInformation
                    isShow={true}
                    currentInfo={{
                        ...currentInfo,
                        natureOfBusiness: currentNatureOfBusinessItem?.name ?? '',
                    }}
                    proposedInfo={{
                        ...proposedBasicInformation,
                        natureOfBusiness: proposedNatureOfBusinessItem?.name ?? '',
                    }}
                    currentAffiliations={currentAffiliations}
                    proposedAffiliations={proposedAffiliations}
                />
                <ProposedAmendGroupProfile
                    isShow={true}
                    currentGroupClassification={currentGroupClassification}
                    proposedGroupClassification={proposedGroupClassification}

                    currentOtherSpecifyGC={currentOthersGroupClassificationValue}
                    proposedOtherSpecifyGC={proposedOtherSpecifGC}

                    currentTypeOfGroup={currentTypeOfGroup}
                    proposedTypeOfGroup={proposedTypeOfGroup}
                    currentOtherSpecifyToG={currentOthersTypeOfGroupValue}
                    proposedOtherSpecifyToG={proposedOthersTypeOfGroup}
                    currentSubType={currentTypeOfGroupSubType}
                    proposedSubType={proposedTypeOfGroupSubtype}

                    currentAgeProfile={currentAgeProfileFormat}
                    proposedAgeProfile={proposedAgeProfileFormat}

                    currentPaymentMode={currentModeOfPayment}
                    proposedPaymentMode={proposedModeOfPayment}
                />
                
                <ProposedProposalConfiguration
                    isShow={true} 
                    currentProposalType={currentProposalTypeState}
                    proposedProposalType={proposedProposalType}

                    currentPrototypeType={currentPrototype}
                    proposedPrototypeType={proposedPrototypeType}

                    currentProductType={currentProduct}
                    proposedProductType={proposedProductType}

                    currentBasicPlan={currentBasicPlan}
                    proposedBasicPlan={proposedBasicPlan}

                    currentIsPrototype={isCurrentPrototype}
                    proposedIsPrototype={proposedIsPrototype}

                    currentIsCustomize={isCurrentCustomized}
                    proposedIsCustomize={proposedIsCustomize}
                />

                <ProposedCoverageLoan
                    currentConfigurationType={currentConfigurationType}
                    proposedConfigurationType={proposedConfigurationType}

                    currentCoverageTypeName={currentCoverage?.name}
                    proposedCoverageTypeName={proposedCoverageType?.name}

                    currentIsLevelRanking={currentIsLevelRankingCoverage}
                    proposedIsLevelRanking={proposedIsLevelRanking}

                    currentIsUniformCoverage={currentIsUniformCoverage}
                    proposedIsUniformCoverage={proposedIsUniformCoverage}

                    currentIsSalaryRank={currentIsSalaryRankCoverage}
                    proposedIsSalaryRank={proposedIsSalaryRank}

                    currentInputsByLevelRanking={currentInputsByLevelRanking}
                    proposedInputsByLevelRanking={proposedLevelRankingInputs}

                    currentInputsByUniformCoverage={currentInputsByUniformCoverage}
                    proposedInputsByUniformCoverage={proposedUniformInputs}

                    currentInputsBySalaryRank={currentInputsBySalaryRank}
                    proposedInputsBySalaryRank={proposedSalaryRankInputs}

                    currentAmountOfLoans={currentAmountOfLoans?.name}
                    proposedAmountOfLoans={proposedAmountOfLoans?.name}

                    currentMinMaxAmount={currentFormatMinMaxAmount}
                    proposedMinMaxAmount={proposedFAmountPortfolio}

                    currentLoanPortfolio={currentFAmountPortfolio}
                    proposedLoanPortfolio={proposedFormatMinMaxAmount}

                    currentPaymentTerm={currentPaymentTerm?.name}
                    proposedPaymentTerm={proposedPaymentTerm?.name}

                    currentLoanMaturity={`${currentMaturityMonths} months`}
                    proposedLoanMaturity={`${proposedMaturityMonths} months`}
                />

                <ProposedCommissionServiceFee
                    isShow={true} 
                    currentCommission={currentCommission}
                    proposedCommission={proposedCommissionValue}
                    currentServiceFee={currentServices}
                    proposedServiceFee={proposedServiceValue}
                />

                <ProposedSupportingDocuments
                    isShow={true} 
                    currentFiles={currentFilesCFE}
                    proposedFiles={proposedFiles}
                />
                <ProposedAmendRiders
                    isShow={true} 
                    current={{
                        selectedRiders: currentRiders,
                        amountOfLoansRiders: currentRidersAmountOfLoans,
                        uniformCoverageRiders: currentRidersUniformCoverage,
                        levelRankingRiders: currentRidersLevelRanking,
                        salaryRankRiders: currentRidersSalaryRank,
                        selectedBMSR: currentRidersBMSR,
                        isAmountOfLoan: currentIsAmountOfLoans,
                        isUniformCoverage: currentIsUniformCoverage,
                        isLevelRanking: currentIsLevelRankingCoverage,
                        isSalaryRank: currentIsSalaryRankCoverage,
                    }}
                    proposed={{
                        selectedRiders: proposedRiders,
                        amountOfLoansRiders: proposedAmountOfLoansRiders,
                        uniformCoverageRiders: proposedUniformRiders,
                        levelRankingRiders: proposedLevelRankingRiders,
                        salaryRankRiders: proposedSalaryRankRiders,
                        selectedBMSR: proposedRiderBMSR,
                        isAmountOfLoan: proposedIsAmountOfLoans,
                        isUniformCoverage: proposedIsUniformCoverage,
                        isLevelRanking: proposedIsLevelRanking,
                        isSalaryRank: proposedIsSalaryRank,
                    }}
                />
                <ProposedAmendBorrowers
                    isShow={true} 
                    current={{
                        borrowerAgeOptionsList: currentBorrowerAgeOptionsList,
                        remainingAgeList: currentRemainingAgeList,
                        isProductGPA: currentIsProductGPA,
                        isProductGCLI: currentIsProductGCLI,
                        isProductGYRT: currentIsProductGYRT,
                        isProductGCI: currentIsProductGCI,
                    }}
                    proposed={{
                        borrowerAgeOptionsList: prosedBorrowerAgeOptionsList,
                        remainingAgeList: proposedRemainingAgeList,
                        isProductGPA: proposedIsProductGPA,
                        isProductGCLI: proposedIsProductGCLI,
                        isProductGYRT: proposedIsProductGYRT,
                        isProductGCI: proposedIsProductGCI,
                    }}
                />
                <ProposedAmendNotes
                    isShow={true} 
                    currentNotes={currentNotesCFE}
                    proposedNotes={proposedNotes}
                />
            </div>
        </>
    )
}